import { Check } from "lucide-react";

const Label = ({ children }) => (
  <p className="text-[10px] uppercase tracking-[0.25em] text-[#6B5CE7] font-medium mt-7 mb-3">{children}</p>
);

const CheckList = ({ items }) => (
  <ul className="space-y-2.5">
    {items.map((it) => (
      <li key={it} className="flex items-start gap-3 text-[#1A1528] text-sm font-light">
        <Check size={16} className="text-[#6B5CE7] shrink-0 mt-1" />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

const Choices = ({ choices, or }) => (
  <div className="space-y-2">
    {choices.map((c, i) => (
      <div key={c}>
        {i > 0 && <p className="font-serif italic text-[#6B5CE7] text-sm pl-1 mb-2">{or}</p>}
        <p className="bg-white/70 border border-[#F5E6A3] rounded-xl px-4 py-3 text-sm text-[#1A1528] font-light">{c}</p>
      </div>
    ))}
  </div>
);

export const ContentSignatureDetails = ({ l, or }) => (
  <div className="flex-1 flex flex-col">
    <p data-testid="signature-price" className="font-serif text-2xl md:text-3xl text-[#1A1528] mt-1">{l.startPrice}</p>
    <Label>{l.choiceTitle}</Label>
    {l.choices ? <Choices choices={l.choices} or={or} /> : <CheckList items={l.options} />}
    <Label>{l.includedTitle}</Label>
    <CheckList items={l.items} />
  </div>
);
